/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/anchor-is-valid */
import { logException } from "@wss/error-tracking";
import React, { useEffect, useState } from "react";
import InternalNotesBody from "./InternalNotesBody";
import InternalNotesHeader from "./InternalNotesHeader";
import { InternalNotesData } from "./InternalNotesResult";
interface Props {
  toggleInternalNotesModal: () => void;
  isVirtual: boolean;
  outletItemNumber: string;
  itemNumber: string;
  groupItemNumber: string;
  groupingItemNumbers: string[];
  internalNotesRef: React.MutableRefObject<null>;
}
const InternalNotesModal = ({
  toggleInternalNotesModal,
  isVirtual,
  itemNumber,
  groupItemNumber,
  groupingItemNumbers,
  internalNotesRef,
  outletItemNumber
}: Props) => {
  const [selectedItemNumber, setSelectedItemNumber] = useState<string>(itemNumber.toUpperCase());
  const [internalNotesDataLoaded, setInternalNotesDataLoaded] = useState<boolean>(false);
  const [internalNotesData, setInternalNotesData] = useState<InternalNotesData>();
  useEffect(() => {
    setInternalNotesDataLoaded(false);
    const fetchInternalNotesData = async () => {
      try {
        const response = await fetch(`/api/productdetails/internalnotes?itemNumber=${encodeURIComponent(selectedItemNumber)}`);
        const data: unknown = await response.json();
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        const internalNotesData = data as InternalNotesData;
        setInternalNotesData(internalNotesData);
      } catch (error) {
        await logException(error);
      }
      setInternalNotesDataLoaded(true);
    };
    fetchInternalNotesData();
  }, [selectedItemNumber]);
  return <div id="web-internal" ref={internalNotesRef} data-sentry-component="InternalNotesModal" data-sentry-source-file="InternalNotesModal.tsx">
      <a className="wi-close leading-[24px]" style={{
      cursor: "pointer"
    }} onClick={toggleInternalNotesModal} role="button" tabIndex={0}>
        &times;
      </a>
      {internalNotesDataLoaded && internalNotesData ? <>
          <InternalNotesHeader isVirtual={isVirtual} groupItemNumber={groupItemNumber} groupingItemNumbers={groupingItemNumbers} selectedItemNumber={selectedItemNumber} setSelectedItemNumber={setSelectedItemNumber} internalNotesData={internalNotesData} />
          <InternalNotesBody internalNotesData={internalNotesData} itemNumber={selectedItemNumber} outletItemNumber={outletItemNumber} />
        </> : <img src="/newwebadmin/images/ajax_loading_no_text.GIF" alt="loading" style={{
      border: "none",
      width: "128px",
      height: "128px",
      position: "absolute",
      left: "35%",
      top: "40%"
    }} />}
    </div>;
};
export default InternalNotesModal;